module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/categoryIcons/nfl/icons_receiving_tds/blue-4dec62bcfce313c700a30a1d59f2dd52.svg";